import { useState } from "react";
import { motion } from "framer-motion";
import { SIMON_LEVELS } from "@/utils/simonGameData";
import { Home, Play, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const SimonGameSettings = ({ onStartGame, onBack }) => {
  const [selectedLevel, setSelectedLevel] = useState(null);

  const options = [
    { id: null, name: "Semua Level", icon: "💡", desc: "Main dari Level 1 sampai 6", color: "#EAB308" },
    ...SIMON_LEVELS.map(l => ({ id: l.id, name: `Lv${l.id} ${l.name}`, icon: l.icon, desc: l.desc, color: l.color })),
  ];

  return (
    <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="w-full max-w-2xl mx-auto">
      <div className="glass-card-strong rounded-2xl p-5 sm:p-6 border border-gold/20"
        style={{ boxShadow: '0 0 30px rgba(234,179,8,0.1)' }}>
        <div className="text-center mb-5">
          <motion.span className="text-4xl block mb-2"
            animate={{ opacity: [1, 0.4, 1], scale: [1, 1.15, 1] }}
            transition={{ duration: 1.5, repeat: Infinity }}>💡</motion.span>
          <h2 className="font-fredoka text-xl sm:text-2xl font-bold text-yellow-400 mb-1">Ikuti Lampu Ajaib</h2>
          <p className="font-fredoka text-gold-light/80 text-sm">Ingat dan ulangi pola yang ditampilkan!</p>
        </div>

        <div className="space-y-2 mb-5">
          {options.map((opt, i) => {
            const isActive = selectedLevel === opt.id;
            return (
              <motion.button key={opt.id ?? "all"} data-testid={`simon-level-${opt.id ?? "all"}`}
                initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}
                onClick={() => setSelectedLevel(opt.id)}
                className={`w-full flex items-center gap-3 rounded-xl p-3 border-2 text-left transition-all ${isActive ? "shadow-lg" : ""}`}
                style={{ borderColor: isActive ? opt.color : `${opt.color}25`, background: isActive ? `${opt.color}15` : 'transparent' }}>
                <span className="text-xl w-8 text-center">{opt.icon}</span>
                <div className="flex-1">
                  <p className="font-fredoka font-bold text-sm" style={{ color: opt.color }}>{opt.name}</p>
                  <p className="font-fredoka text-gold-light/80/70 text-xs">{opt.desc}</p>
                </div>
                {isActive && <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }}><Star className="w-5 h-5 fill-current" style={{ color: opt.color }} /></motion.div>}
              </motion.button>
            );
          })}
        </div>

        <div className="flex flex-col gap-2">
          <Button data-testid="simon-start-btn" onClick={() => onStartGame(selectedLevel)}
            className="w-full font-fredoka font-bold text-brown-dark bg-yellow-400 hover:bg-yellow-500 text-lg py-5">
            <Play className="w-5 h-5 mr-2" />Mulai!
          </Button>
          <Button onClick={onBack} variant="outline" className="w-full border-gold/20 text-pink-300 hover:bg-gold/10 font-fredoka"
            data-testid="simon-settings-back-btn">
            <Home className="w-4 h-4 mr-2" />Kembali ke Menu Utama
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default SimonGameSettings;
